module.exports = __webpack_public_path__ + "static/co-fes-logo-white@3x-8d6291fef65967d929a07b62c2829fa2.png";